/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';

/* Initial State */
const initialState = {
  loading: false,
};

/* Slice */
export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    startApplicationLoading(state) {
      state.loading = true;
    },
    stopApplicationLoading(state) {
      state.loading = false;
    },
  },
});

/* Selectors */
const selectApplication = state => state[applicationSlice.name];
export const isApplicationLoading = createSelector(selectApplication, ({ loading }) => loading);

/* Actions */
export const { startApplicationLoading, stopApplicationLoading } = applicationSlice.actions;
